import { Component, OnInit, DoCheck, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
})
export class FooterComponent implements OnInit {
  currentYear: number = new Date().getFullYear();
  legal = {
    FileUri: "https://blobleapmotor.blob.core.windows.net/images/legales/MiLeapmotor-Aviso-Legal.pdf"
  };
  constructor() {}

  ngOnInit(): void {}
}
